"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteLayout = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_router_dom_1 = require("react-router-dom");
var SiteLayout = function () {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {}) }));
};
exports.SiteLayout = SiteLayout;
